import { render, staticRenderFns } from "./SwipeCard.vue?vue&type=template&id=747a52c4&scoped=true&"
import script from "./SwipeCard.vue?vue&type=script&lang=js&"
export * from "./SwipeCard.vue?vue&type=script&lang=js&"
import style0 from "./SwipeCard.vue?vue&type=style&index=0&id=747a52c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747a52c4",
  null
  
)

export default component.exports